/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';

import { VApplication } from '../application/index';
import { GET_STORES } from '../pages/StoresList/graphql/get-stores.query';

import {STORES_DATA} from './config/stores-list-data';
import { toast } from "react-hot-toast";
import { humanize } from "uno-js";
import {getErrorMessage} from "../utils/error.message";

const SERVICE_NAME = 'stores.service';
const { LoggerModule } = require("@vlinder-web/logger-module-react");
const log: any = LoggerModule.getInstance();

const is = require('is_js');


const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export class SoldStoresService {
    name = SERVICE_NAME;
    private static instance: SoldStoresService;
    private constructor() {
        this.report();
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new SoldStoresService();
        }
        return this.instance;
    }
    async init() {}

    async getStores() {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient('api-gateway');
        try {
            // if (client) {
            //     const res = await client.query({
            //         query: GET_COUNTRY,
            //         variables: {
            //             countryCode: 'IN',
            //         },
            //     });
            //     log.info(SERVICE_NAME,'getCountry: ', res);
            //     return res?.data?.country;
            // }
            let result = STORES_DATA;
            let _applications = {
                pagination: {
                    nextOffset: 4,
                    totalItems: 4,
                },
                results: [...result],
            };
            
            return _applications;

        } catch (err:any) {
           getErrorMessage(err);
            // return {
            //     error: err?.message,
            // };
        }
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, 'Module Report');
        log?.info(SERVICE_NAME, '⦿ Name: ' + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
